import { Box, Colors, Icon, type MediumIcon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  mood?: number
  withLabel?: boolean
  hasComment?: boolean
}

const moodIcons: Record<string, MediumIcon> = {
  1: 'face-super-negative',
  2: 'face-negative',
  3: 'face-neutral',
  4: 'face-positive',
  5: 'face-super-positive',
}

const moodIconsFillColor: Record<string, Colors> = {
  1: 'moodSuperNegative',
  2: 'moodNegative',
  3: 'moodNeutral',
  4: 'moodPositive',
  5: 'moodSuperPositive',
}

export const getEmployeeMoodToolTip = (position: number): string => {
  switch (position) {
    case 1:
      return i18n.t('engagement.employee_pulse_labels.1')
    case 2:
      return i18n.t('engagement.employee_pulse_labels.2')
    case 3:
      return i18n.t('engagement.employee_pulse_labels.3')
    case 4:
      return i18n.t('engagement.employee_pulse_labels.4')
    case 5:
      return i18n.t('engagement.employee_pulse_labels.5')
    default:
      return ''
  }
}

export function EmployeePulseIcon({ mood, withLabel = false, hasComment = false }: Props) {
  const getMoodIcon = (moodValue: number): MediumIcon => {
    return moodIcons[moodValue] ?? 'face-neutral'
  }

  const getMoodIconsFillColor = (moodValue: number): Colors => {
    return moodIconsFillColor[moodValue] ?? 'champagne100'
  }

  if (!mood) {
    return (
      <Box width="s24" height="s24" alignItems="center" justifyContent="center">
        <Box width="s16" height="s16" background="grey300" borderRadius={{ all: 'rel1000' }} />
      </Box>
    )
  }

  const renderMoodIcon = () => (
    <Box position="relative">
      {hasComment && (
        <Box
          position="absolute"
          alignItems="center"
          justifyContent="center"
          width="s6"
          height="s6"
          background="white"
          borderRadius={{ all: 'rel1000' }}
          style={{
            zIndex: '1',
            top: '2px',
            right: '4px',
          }}
        >
          <Box
            position="absolute"
            width="s4"
            height="s4"
            background="grey800"
            borderRadius={{ all: 'rel1000' }}
          />
        </Box>
      )}
      <Icon.Medium icon={getMoodIcon(mood)} color={getMoodIconsFillColor(mood)} />
    </Box>
  )

  if (withLabel) {
    return (
      <Box flexDirection="row" gap="s6">
        {renderMoodIcon()}
        <Text.Normal>{getEmployeeMoodToolTip(mood)}</Text.Normal>
      </Box>
    )
  }

  return renderMoodIcon()
}
